/**
 * @generated SignedSource<<fff178e99dd5ecc71919553a17e63112>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type ReservationStatus = "CANCELLED" | "CHECKED_OUT" | "CONFIRMED" | "DRAFT" | "PICKED" | "REQUESTED" | "RETURNED" | "%future added value";
export type OpsCustomersPageQuery$variables = {
  search?: string | null | undefined;
};
export type OpsCustomersPageQuery$data = {
  readonly customers: {
    readonly nodes: ReadonlyArray<{
      readonly email: string | null | undefined;
      readonly id: string;
      readonly name: string;
      readonly phone: string | null | undefined;
      readonly reservations: ReadonlyArray<{
        readonly id: string;
        readonly status: ReservationStatus;
      }>;
    } | null | undefined> | null | undefined;
  };
};
export type OpsCustomersPageQuery = {
  response: OpsCustomersPageQuery$data;
  variables: OpsCustomersPageQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "search"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Literal",
        "name": "first",
        "value": 200
      },
      {
        "kind": "Variable",
        "name": "search",
        "variableName": "search"
      }
    ],
    "concreteType": "CustomerConnection",
    "kind": "LinkedField",
    "name": "customers",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Customer",
        "kind": "LinkedField",
        "name": "nodes",
        "plural": true,
        "selections": [
          (v1/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "name",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "email",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "phone",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Reservation",
            "kind": "LinkedField",
            "name": "reservations",
            "plural": true,
            "selections": [
              (v1/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "status",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "OpsCustomersPageQuery",
    "selections": (v2/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "OpsCustomersPageQuery",
    "selections": (v2/*: any*/)
  },
  "params": {
    "cacheID": "4f58122e66f2a04c91b7bcaccf43ed44",
    "id": null,
    "metadata": {},
    "name": "OpsCustomersPageQuery",
    "operationKind": "query",
    "text": "query OpsCustomersPageQuery(\n  $search: String\n) {\n  customers(search: $search, first: 200) {\n    nodes {\n      id\n      name\n      email\n      phone\n      reservations {\n        id\n        status\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "7edee90b371247f926b7ca4773f2dd10";

export default node;
